// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2RSjk","name":"Header_name__3FoAm","birthday":"Header_birthday__3rZct","skeleton":"Header_skeleton__mwj3J"};